import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SessionKvService } from './sessionkv.service';
import {
  PortOrder, SessionValueStoreEntry
} from '@proto/odoo/sessionkv';
import {Model} from "../app.model";
import { PortOrderDraft } from './sessionkv-port-order';

@Injectable({
  providedIn: 'root'
})
export class SessionKvPortOrderService {
  constructor(
    private sessionKvService: SessionKvService,
    private m: Model
  ) {}

  /**
   * Save a PortOrder to the session store
   */
  save(data: {
    name?: string
    portOrder: PortOrder;
  }): Observable<SessionValueStoreEntry> {
    const entryName = data.name ?? `companies/company-${this.m.account.currentUser.companyId}/contacts/contact-${this.m.account.currentUser.id}/portorders/portorder-${this.sessionKvService.generateUuid()}`;
    const entry = SessionValueStoreEntry.create({
      name: entryName,
      value: {
        $case: 'portOrder',
        portOrder: data.portOrder
      }
    })

    return this.sessionKvService.createOrUpdateEntry(entry);
  }

  /**
   * Delete a PortOrder from the session store
   */
  delete(name: string): Observable<void> {
    return this.sessionKvService.deleteEntry(name);
  }

  /**
   * Load session store and return all PortOrder entries
   */
  loadAll(): Observable<PortOrderDraft[]> {
    return this.sessionKvService.loadSessionStore().pipe(
      map(sessionStore => {
        return this.sessionKvService.findEntriesByOneOfCase<PortOrder>(
          sessionStore,
          'portOrder'
        ).map(item => ({
          name: item.name,
          portOrder: item.value
        }));
      })
    );
  }
}
